export const LogoAdmin = () => {
  return (
    <div className="p-4 h-24">
      <h1 className="font-black text-xl">Baloon</h1>
    </div>
  )
}
